export default function getPageviewData() {
    const data = {};
    
    // Den Kategoriepfad stellt aktuell der Shop bereit, daher ist die HTML Struktur nicht völlig
    // unter unserer Kontrolle. Vorsicht!
    const kategoriePfadKnoten = document.querySelectorAll('nav[role="navigation"] ul.breadcrumbs li a');
    let knoten = [];
    for (let i = 0; i < kategoriePfadKnoten.length; i++) {
        const knotenAnchorElement = kategoriePfadKnoten[i];
        knoten.push({
            url: knotenAnchorElement.href,
            name: knotenAnchorElement.textContent.trim()
        });
    }
    data.kategoriepfad = knoten;
    
    // Wenn der Content-Bereich die Klasse 'kategorie-listen-suche' hat, zeigen wir eine Kategorieseite an,
    // andernfalls eine Bereichsseite.
    const kategorieListeKnoten = document.querySelector('div#suchecontent.kategorie-listen-suche');
    if (kategorieListeKnoten !== null) {
        data.seitenTyp = 'kategorie';
        let dataset = kategorieListeKnoten.dataset;
        data.environment = dataset.environment;
        data.mandant = dataset.mandant;
    } else {
        data.seitenTyp = 'bereich';
        const bereichsListeKnoten = document.querySelector('div#suchecontent.bereichs-listen-suche');
        if (bereichsListeKnoten !== null) {
            let dataset = bereichsListeKnoten.dataset;
            data.environment = dataset.environment;
            data.mandant = dataset.mandant;
        }
    }

    // Zu Tracking-Zwecken schreiben wir noch den Namen der aktuellen Kategorie
    // in das Datalayer. Den Namen leiten wir aus dem letzten Pfadelement des Canonical-Tags ab.
    let canonicalUrl = document.querySelector("link[rel='canonical']").getAttribute("href");
    let lastSlash = canonicalUrl.lastIndexOf("/");
    canonicalUrl = canonicalUrl.substr(0, lastSlash);
    lastSlash = canonicalUrl.lastIndexOf("/");
    data.kategorieoderbereichname = canonicalUrl.substr(lastSlash + 1);

    return data;
}